import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
  Spinner,
} from "react-bootstrap";

import "../../../assets/css/user/cart/MyCart.css";

import Navbar from "../../../components/user/navbar/Navbar";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
import Footer from "../../../components/user/footer/Footer";

import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";

import TpDealCard from "../../../components/user/card/dealCard/TpDealCard";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";

export default function Cart() {
  const [items, setItems] = useState([]);

  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [dealSubTotalAmount, setDealSubTotalAmount] = useState(0);

  const [loading, setLoading] = useState(false);
  const [cartLoading, setCartLoading] = useState(true);

  // =========================================================
  // SHIPPING ADDRESS POPUP
  // =========================================================

  const [showAddressModal, setShowAddressModal] = useState(false);

  const [shippingAddress, setShippingAddress] = useState({
    fullName: "",
    phone: "",
    address: "",
    city: "",
    postalCode: "",
  });

  const { baseUrl } = useContext(AppContext);

  const navigate = useNavigate();

  // =========================================================
  // GET CART ITEMS
  // =========================================================

  const getCartItems = () => {
    setCartLoading(true);
    let savedCustomer = null;

    try {
      savedCustomer = JSON.parse(localStorage.getItem("loggedInUser"));
    } catch (error) {
      console.log("Customer parse error:", error);
    }

    if (!savedCustomer?.id) {
      setItems([]);
      setSubTotalAmount(0);
      setDealSubTotalAmount(0);
      setCartLoading(false);
      return;
    }

    const formData = new FormData();

    formData.append("tpcustomer_id", savedCustomer.id);

    axios
      .post(`${baseUrl}/customer/cart/getCart`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("Cart Data:", response.data);

        if (response.data?.success) {
          setItems(response.data.deals || []);

          setSubTotalAmount(response.data.acutal_price_total || 0);

          setDealSubTotalAmount(response.data.deal_price_total || 0);
        } else {
          setItems([]);
          setSubTotalAmount(0);
          setDealSubTotalAmount(0);
        }
      })
      .catch((error) => {
        console.log("Cart Error:", error);

        setItems([]);
        setSubTotalAmount(0);
        setDealSubTotalAmount(0);
      })
      .finally(() => {
        setCartLoading(false);
      });
  };

  // =========================================================
  // GET CUSTOMER SHIPPING ADDRESS
  // =========================================================

  const getShippingAddress = () => {
    let savedCustomer = null;

    try {
      savedCustomer = JSON.parse(localStorage.getItem("loggedInUser"));
    } catch (error) {
      console.log("Customer parse error:", error);
    }

    if (!savedCustomer?.id) {
      Swal.fire({
        icon: "warning",
        title: "Login Required",
        text: "Please login before placing an order.",
        confirmButtonText: "Login",
      });

      navigate("/login");

      return;
    }

    // CUSTOMER NAME
    const customerName =
      savedCustomer.fullName ||
      savedCustomer.name ||
      savedCustomer.customer_name ||
      "";

    // CUSTOMER PHONE
    const customerPhone =
      savedCustomer.phone ||
      savedCustomer.mobile ||
      savedCustomer.phoneNumber ||
      "";

    // CUSTOMER ADDRESS
    const customerAddress =
      savedCustomer.address ||
      savedCustomer.customer_address ||
      savedCustomer.shipping_address ||
      savedCustomer.businessAddress ||
      "";

    // CUSTOMER CITY
    const customerCity =
      savedCustomer.city || savedCustomer.customer_city || "";

    // CUSTOMER POSTAL CODE
    const customerPostalCode =
      savedCustomer.postalCode ||
      savedCustomer.postal_code ||
      savedCustomer.zipCode ||
      savedCustomer.zip_code ||
      "";

    setShippingAddress({
      fullName: customerName,
      phone: customerPhone,
      address: customerAddress,
      city: customerCity,
      postalCode: customerPostalCode,
    });

    setShowAddressModal(true);
  };

  // =========================================================
  // ORDER NOW
  // =========================================================

  const handleOrderNow = () => {
    if (items.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Cart is Empty",
        text: "Please add a deal to your cart first.",
        confirmButtonText: "Okay",
      });

      return;
    }

    // CHECK SOLD DEAL
    const soldDeal = items.find(
      (item) => item?.tpdeal?.status?.toLowerCase() === "sold",
    );

    if (soldDeal) {
      Swal.fire({
        icon: "warning",
        title: "Deal Sold Out",
        text: `"${soldDeal?.tpdeal?.deal_title || "This deal"}" is already sold and cannot be purchased.`,
        confirmButtonText: "Okay",
      });

      return;
    }

    getShippingAddress();
  };

  // =========================================================
  // SHIPPING ADDRESS INPUT CHANGE
  // =========================================================

  const handleAddressChange = (e) => {
    const { name, value } = e.target;

    setShippingAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // =========================================================
  // CREATE ORDER
  // =========================================================

  const handleCheckout = async () => {
  // =========================================================
  // CUSTOMER
  // =========================================================

  let savedCustomer = null;

  try {
    savedCustomer = JSON.parse(
      localStorage.getItem("loggedInUser")
    );
  } catch (error) {
    console.log("Customer parse error:", error);
  }

  if (!savedCustomer?.id) {
    Swal.fire({
      icon: "warning",
      title: "Login Required",
      text: "Please login before checkout.",
      confirmButtonText: "Login",
    });

    navigate("/login");

    return;
  }

  // =========================================================
  // PREVENT DOUBLE CLICK
  // =========================================================

  if (loading) {
    return;
  }

  setLoading(true);

  try {
    // =======================================================
    // FORM DATA
    // =======================================================

    const formData = new FormData();

    formData.append(
      "tpcustomer_id",
      savedCustomer.id
    );

    // Shipping fields optional hain
    formData.append(
      "shipping_name",
      shippingAddress.fullName?.trim() || ""
    );

    formData.append(
      "shipping_phone",
      shippingAddress.phone?.trim() || ""
    );

    formData.append(
      "shipping_address",
      shippingAddress.address?.trim() || ""
    );

    formData.append(
      "shipping_city",
      shippingAddress.city?.trim() || ""
    );

    formData.append(
      "shipping_postal_code",
      shippingAddress.postalCode?.trim() || ""
    );

    console.log("Creating order...");
    console.log("Customer ID:", savedCustomer.id);

    // =======================================================
    // CREATE ORDER API
    // =======================================================

    const response = await axios.post(
      `${baseUrl}/customer/orders/createOrder`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log(
      "Create Order Response:",
      response.data
    );

    // =======================================================
    // SUCCESS
    // =======================================================

    if (response.data?.success) {
      const createdOrders =
        response.data?.orders || [];

      const singleOrder =
        response.data?.order || null;

      // At least one order must be returned
      if (
        createdOrders.length === 0 &&
        !singleOrder
      ) {
        Swal.fire({
          icon: "error",
          title: "Order Created But No Details",
          text:
            "The order was created but order details were not returned by the server.",
          confirmButtonText: "Okay",
        });

        return;
      }

      // Close shipping modal
      setShowAddressModal(false);

      // Refresh cart
      getCartItems();

      // =====================================================
      // GO TO CHECKOUT
      // =====================================================

      navigate("/checkout", {
        state: {
          orders:
            createdOrders.length > 0
              ? createdOrders
              : [singleOrder],

          checkoutData: {
            tpcustomer_id:
              savedCustomer.id,

            shipping_name:
              shippingAddress.fullName,

            shipping_phone:
              shippingAddress.phone,

            shipping_address:
              shippingAddress.address,

            shipping_city:
              shippingAddress.city,

            shipping_postal_code:
              shippingAddress.postalCode,

            subtotal:
              Number(subTotalAmount),

            total:
              Number(dealSubTotalAmount),
          },
        },
      });

      return;
    }

    // =======================================================
    // BACKEND ERROR
    // =======================================================

    Swal.fire({
      icon: "error",
      title: "Order Failed",
      text:
        response.data?.message ||
        "Unable to place your order. Please try again.",
      confirmButtonText: "Okay",
    });
  } catch (error) {
    console.error(
      "CREATE ORDER ERROR:",
      error
    );

    console.error(
      "CREATE ORDER BACKEND RESPONSE:",
      error?.response?.data
    );

    const backendMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Unable to place your order. Please try again.";

    Swal.fire({
      icon: "error",
      title: "Order Failed",
      text: backendMessage,
      confirmButtonText: "Okay",
    });
  } finally {
    setLoading(false);
  }
};

  // =========================================================
  // DISCOUNT
  // =========================================================

  const discountAmount = Number(subTotalAmount) - Number(dealSubTotalAmount);

  const discount_percentage =
    Number(subTotalAmount) > 0
      ? Math.round((discountAmount / Number(subTotalAmount)) * 100)
      : 0;

  // =========================================================
  // LOAD CART
  // =========================================================

  useEffect(() => {
    getCartItems();
  }, []);

  // =========================================================
  // JSX
  // =========================================================

  return (
    <div className="cart-page">
      <MarqueeBanner />

      <Navbar />

      <SimpleBanner
        title="Cart"
        subtitle=""
        breadcrumbs={[
          {
            label: "Home",
            href: "/",
          },
          {
            label: "Cart",
            href: "/cart",
          },
        ]}
      />

      <div className="cart-content">
        <div className="cart-heading">
          <h1 className="cart-title">Shopping Cart</h1>

          <p className="cart-sub">
            {items.length} item
            {items.length !== 1 ? "s" : ""} in your cart
          </p>
        </div>

        <Container fluid className="px-0">
          <Row className="cart-body g-4 mt-3 mb-3">
            {/* =================================================
                CART ITEMS
            ================================================= */}

            <Col xs={12} lg={8}>
              {cartLoading ? (
                // ==============================
                // CART LOADING
                // ==============================
                <Card className="cart-card">
                  <Card.Body
                    className="text-center py-5"
                    style={{
                      minHeight: "250px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Spinner animation="border" role="status" size="lg" />

                    <p className="mt-3 text-muted mb-0">Loading your cart...</p>
                  </Card.Body>
                </Card>
              ) : items.length === 0 ? (
                // ==============================
                // EMPTY CART
                // ==============================
                <Card className="cart-card empty-card">
                  <Card.Body className="text-center py-5">
                    <div className="empty-icon">🛒</div>

                    <p className="empty-text">Your cart is empty.</p>
                  </Card.Body>
                </Card>
              ) : (
                // ==============================
                // CART ITEMS
                // ==============================
                <Row>
                  {items.map((item) => (
                    <TpDealCard
                      key={item.id}
                      deal={item.tpdeal}
                      isAlreadyInCart={true}
                      getCartItems={getCartItems}
                      onRemove={() =>
                        setItems((prev) =>
                          prev.filter((i) => i.tpdeal?.id !== item.tpdeal?.id),
                        )
                      }
                    />
                  ))}
                </Row>
              )}
            </Col>

            {/* =================================================
                ORDER SUMMARY
            ================================================= */}

            <Col xs={12} lg={4}>
              <Card className="summary-card">
                <Card.Body>
                  <h3 className="summary-title">Order Summary</h3>

                  <div className="summary-row">
                    <span>Subtotal (Actual Price)</span>

                    <span>PKR {Number(subTotalAmount).toLocaleString()}</span>
                  </div>

                  {discount_percentage > 0 && (
                    <div className="summary-row discount">
                      <span>Discount ({discount_percentage}%)</span>

                      <span>
                        - PKR {Number(discountAmount).toLocaleString()}
                      </span>
                    </div>
                  )}

                  <hr className="summary-divider" />

                  <div className="summary-row total">
                    <span>Total (After Discount)</span>

                    <span>
                      PKR {Number(dealSubTotalAmount).toLocaleString()}
                    </span>
                  </div>

                  <Button
                    className="btn-checkout"
                    disabled={items.length === 0 || loading}
                    onClick={handleOrderNow}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          size="sm"
                          animation="border"
                          className="me-2"
                        />
                        Processing...
                      </>
                    ) : (
                      "Confirm"
                    )}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* =====================================================
          SHIPPING MODAL
      ===================================================== */}

      <Modal
        show={showAddressModal}
        onHide={() => {
          if (!loading) {
            setShowAddressModal(false);
          }
        }}
        centered
        size="md"
        className="shipping-address-modal"
        backdrop="static"
      >
        <Modal.Header closeButton={!loading}>
          <Modal.Title>Shipping Address</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="shipping-address-description">
            Please confirm your shipping address before placing your order.
          </p>

          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>

              <Form.Control
                type="text"
                name="fullName"
                value={shippingAddress.fullName}
                onChange={handleAddressChange}
                placeholder="Enter full name"
                disabled={loading}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>

              <Form.Control
                type="text"
                name="phone"
                value={shippingAddress.phone}
                onChange={handleAddressChange}
                placeholder="Enter phone number"
                disabled={loading}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Shipping Address</Form.Label>

              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                value={shippingAddress.address}
                onChange={handleAddressChange}
                placeholder="Enter complete shipping address"
                disabled={loading}
              />
            </Form.Group>

            <Row>
              <Col md={7}>
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>

                  <Form.Control
                    type="text"
                    name="city"
                    value={shippingAddress.city}
                    onChange={handleAddressChange}
                    placeholder="Enter city"
                    disabled={loading}
                  />
                </Form.Group>
              </Col>

              <Col md={5}>
                <Form.Group className="mb-3">
                  <Form.Label>Postal Code</Form.Label>

                  <Form.Control
                    type="text"
                    name="postalCode"
                    value={shippingAddress.postalCode}
                    onChange={handleAddressChange}
                    placeholder="Optional"
                    disabled={loading}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>

          <div className="shipping-total-box">
            <span>Order Total</span>

            <strong>PKR {Number(dealSubTotalAmount).toLocaleString()}</strong>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={loading}
            onClick={() => setShowAddressModal(false)}
          >
            Cancel
          </Button>

          <Button
            className="btn-proceed-checkout"
            disabled={loading}
            onClick={handleCheckout}
          >
            {loading ? (
              <>
                <Spinner size="sm" animation="border" className="me-2" />
                Placing Order...
              </>
            ) : (
              "Confirm Order"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </div>
  );
}
